import { Controller } from "@hotwired/stimulus"

// Manages file upload preview for teacher communication step 2.
// Shows selected files with name, size, and a remove button.
export default class extends Controller {
  static targets = ["input", "list"]

  connect() {
    this._onChange = () => this._render()
    this.inputTarget.addEventListener("change", this._onChange)
  }

  disconnect() {
    this.inputTarget.removeEventListener("change", this._onChange)
  }

  remove(event) {
    const idx = parseInt(event.params.index, 10)
    const dt = new DataTransfer()
    Array.from(this.inputTarget.files).forEach((file, i) => {
      if (i !== idx) dt.items.add(file)
    })
    this.inputTarget.files = dt.files
    this._render()
  }

  // ---- private ----

  _render() {
    this.listTarget.innerHTML = ""
    Array.from(this.inputTarget.files).forEach((file, index) => {
      this.listTarget.insertAdjacentHTML(
        "beforeend",
        this._fileItemHTML(file, index),
      )
    })
  }

  _fileItemHTML(file, index) {
    const ext = file.name.split(".").pop().toUpperCase()
    const size = this._formatSize(file.size)
    return `
      <div class="bg-input rounded p-3 flex items-center gap-[21px]">
        <div class="relative w-fit shrink-0">
          <svg width="25" height="33" viewBox="0 0 25 33" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M3.84 0H15.47C15.65.22 15.62.48 15.62.74
                     C15.62 3.39 15.62 6.04 15.62 8.69C15.62
                     9.23 15.9 9.5 16.44 9.5C18.85 9.5 21.27
                     9.5 23.68 9.5C24.04 9.5 24.41 9.5 24.77
                     9.57C24.93 9.62 24.97 9.75 24.98
                     9.9C24.99 10.07 24.99 10.24 24.99
                     10.41C24.99 16.53 24.97 22.64 25
                     28.75C25.01 30.41 23.87 32.17 22.21
                     32.79C21.77 32.96 21.3 32.98 20.84
                     32.98C15.28 32.99 9.72 32.96 4.15
                     33C1.57 33.02 0 30.58 0 28.84C.03
                     20.59 0 12.35.02 4.1C.03 2.3 1 1.07
                     2.56.26C2.96.05 3.42.09 3.84 0Z"
                  fill="#CA4242"/>
            <path d="M15.53 0C16.31.82 17.08 1.64 17.86
                     2.45C20.09 4.77 22.32 7.09 24.56
                     9.42C24.63 9.49 24.7 9.58 24.77
                     9.66C21.8 9.66 18.83 9.65 15.86
                     9.66C15.55 9.66 15.46 9.57 15.46
                     9.26C15.47 6.17 15.47 3.09 15.47
                     0H15.53Z" fill="#FF595D"/>
          </svg>
          <span class="absolute top-1/2 left-1/2 -translate-x-1/2
                       -translate-y-1/4 text-xs font-medium text-white
                       z-[1] text-[50%] uppercase">${ext}</span>
        </div>
        <div class="flex flex-col flex-1 min-w-0">
          <span class="text-sm truncate">${this._escapeHTML(file.name)}</span>
          <span class="text-xs text-gray-400">${size}</span>
        </div>
        <button type="button"
                data-action="teacher-file-upload#remove"
                data-teacher-file-upload-index-param="${index}"
                class="shrink-0">
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="40" rx="20" fill="#EEF2F5"/>
            <path d="M22 17.82L21.74 24.36M18.26
                     24.36L18.01 17.82M25.26
                     15.48C25.51 15.52 25.75 15.56 26
                     15.6M25.26 15.48L24.48
                     25.58C24.45 25.99 24.26 26.38 23.96
                     26.66C23.66 26.94 23.26 27.09 22.85
                     27.09H17.15C16.74 27.09 16.34 26.94
                     16.04 26.66C15.74 26.38 15.55 25.99
                     15.52 25.58L14.74
                     15.48M25.26 15.48C24.42 15.36 23.57
                     15.26 22.73 15.2M14.74
                     15.48C14.49 15.52 14.25 15.56 14
                     15.6M14.74 15.48C15.58 15.36 16.43
                     15.26 17.27 15.2M22.73
                     15.2V14.53C22.73 13.67 22.07 12.96
                     21.21 12.93C20.4 12.9 19.6 12.9
                     18.79 12.93C17.93 12.96 17.27 13.67
                     17.27 14.53V15.2M22.73
                     15.2C20.91 15.06 19.09 15.06 17.27
                     15.2" stroke="black" stroke-linecap="round"
                  stroke-linejoin="round"/>
          </svg>
        </button>
      </div>`
  }

  _formatSize(bytes) {
    if (bytes === 0) return "0 B"
    const k = 1024
    const units = ["B", "KB", "MB", "GB"]
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${units[i]}`
  }

  _escapeHTML(str) {
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
